import gql from 'graphql-tag';
import {
  PAYMENT_METHOD_FRAGMENT,
  achPaymentMethod,
  creditCardPaymentMethod,
} from 'pages/settings/secondary/payment-methods/payment-methods.api';

export const POLL_PAYMENT_METHODS = gql`
  query PollPaymentMethods($accountId: Int!) {
    account(id: $accountId) {
      id
      paymentMethods {
        ...paymentMethodData
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;

export const pollingMock = {
  account: {
    id: 2,
    paymentMethods: [achPaymentMethod, creditCardPaymentMethod],
  },
};
